import { render } from "./SideBarNav.vue?vue&type=template&id=5bcc1ada&scoped=true&ts=true"
import script from "./SideBarNav.vue?vue&type=script&lang=ts"
export * from "./SideBarNav.vue?vue&type=script&lang=ts"

import "./SideBarNav.vue?vue&type=style&index=0&id=5bcc1ada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcc1ada"]])

export default __exports__